import { default as Pagination } from './pagination'
import { TimeRangePicker , TimePicker } from './timepicker'
import { default as SearchCombo } from './search-combo'
import { default as Area } from './area'
import AreaSelect from './area/area-select'
import { default as Select } from './select'
import { default as Post } from './select/post'
import { default as CompanyCascader } from './company-cascader'
import { default as Permission } from './permission'
import { default as AuthTree } from './auth-tree'
import { default as A } from './a'
import { default as Qrcode } from './qrcode'
import { Form, FormItem } from './form'
import { Table, TableCell } from './table'
import { default as Page } from './page'
import { default as Modal } from './modal'
import { default as SidePanel } from './side-panel'
import { Upload, UploadFile } from './upload'
import { Img, ImgGroup } from './img'
import More from './more'
import SMSVerify from './sms-verify'
import Download from './download'

const Components = [Pagination, TimeRangePicker, TimePicker, SearchCombo, Area, Select, CompanyCascader, Permission, AuthTree, A, Qrcode, Form, FormItem, Table, TableCell, Page, Modal, SidePanel, Upload, UploadFile, Img, ImgGroup, Post , More,SMSVerify,AreaSelect,Download]

const prefix = 'sl'

let customComponents = {}

const install = (Vue) => {
  Components.forEach(i => {
    if (i.install) {
      Vue.use(i)
    } else {
      Vue.component(prefix + i.name, i)
    }
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

customComponents.install = install

export default customComponents
